import { render, staticRenderFns } from "./ModalSuggestedStatus.vue?vue&type=template&id=04aa0099&scoped=true"
import script from "./ModalSuggestedStatus.vue?vue&type=script&lang=js"
export * from "./ModalSuggestedStatus.vue?vue&type=script&lang=js"
import style0 from "./ModalSuggestedStatus.vue?vue&type=style&index=0&id=04aa0099&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa0099",
  null
  
)

export default component.exports